import React from "react"
import CheckoutModalDiscount from "../Checkout/CheckoutModalDiscount"
import { useAtom as GetAtom } from "jotai"
import {
  checkoutDiscountButtonDisabledAtom,
  checkoutModalDiscountOpenAtom,
  checkoutStepAtom,
} from "../../store/checkout"
import classNames from "classnames"

function NavSaleSubMenu() {
  const [checkoutStep] = GetAtom(checkoutStepAtom)
  const [isDisabledDiscountButton] = GetAtom(checkoutDiscountButtonDisabledAtom)
  const [, setOpen] = GetAtom(checkoutModalDiscountOpenAtom)

  return (
    <div className={classNames({ hidden: checkoutStep === "2" })}>
      <nav className="flex space-x-4">
        <button
          type="button"
          className={classNames(
            "flex-1",
            "text-base",
            "bg-opacity-30 cursor-not-allowed",
            "h-12",
            "rounded-md bg-white px-3 py-2 text-sm font-medium"
          )}
          disabled={true}
        >
          Дисконтная карта (Скоро)
        </button>

        <button
          type="button"
          className={classNames(
            "flex-1",
            "text-base",
            isDisabledDiscountButton
              ? "bg-opacity-30 cursor-not-allowed"
              : "hover:bg-opacity-75",
            "h-12",
            "rounded-md bg-white px-3 py-2 text-sm font-medium"
          )}
          disabled={isDisabledDiscountButton}
          onClick={() => {
            if (isDisabledDiscountButton) {
              return false
            }

            setOpen(true)
          }}
        >
          Скидка на чек
        </button>
      </nav>

      <CheckoutModalDiscount />
    </div>
  )
}

export default NavSaleSubMenu
